import Home from './pages/home';
import "./i18n";

function App() {
  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App; 